import { Breadcrumbs, Typography, Link } from "@mui/material";
import { NAV_MENUS } from "../../layout/ActionHeader";
import { useNavigate, useLocation } from "react-router-dom";
import { useLanguage } from "../../../context/LanguageContext";

const AppBreadcrumbs = ({ onParentClick, lastLabel }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { language } = useLanguage();

  const pathname = location.pathname;

  let parentLabel = null;
  let parentPath = null;
  let childLabel = null;

  NAV_MENUS.forEach((menu) => {
    const matchedItem = menu.items.find((item) =>
      pathname.startsWith(item.path) // supports nested routes also
    );

    if (matchedItem) {
      parentLabel = menu.label(language);
      childLabel = matchedItem.label(language);
      // navigate to first item of that menu (or you can set custom parent route)
      parentPath = menu.items[0]?.path;
    }
  });

  const handleParentClick = () => {
    if (onParentClick) {
      onParentClick();
    } else if (parentPath) {
      navigate(parentPath);
    } else {
      navigate(-1);
    }
  };



  return (
    <Breadcrumbs
      sx={{
        mb: 2,
        fontSize: 12,
        "& .MuiLink-root": { fontSize: 12, cursor: "pointer" },
        "& .MuiTypography-root": { fontSize: 12 },
      }}
    >
      {/* HOME (Clickable) */}
      <Link underline="hover" onClick={() => navigate("/")}>
        {language === "mr" ? "मुख्यपृष्ठ" : "Home"}
      </Link>

      {/* PARENT MENU (Now Clickable) */}
      {parentLabel && (
        <Link
          underline="hover"
          onClick={onParentClick ? handleParentClick : () => navigate(parentPath)}
          sx={{ cursor: "pointer" }}
        >
          {parentLabel}
        </Link>
      )}

      {/* CURRENT PAGE (Not Clickable) */}
      {childLabel && (
        lastLabel ? (
          <Link underline="hover" onClick={handleParentClick}>
            {childLabel}
          </Link>
        ) : (
          <Typography color="text.primary" fontWeight={600}>
            {childLabel}
          </Typography>
        )
      )}

      {lastLabel && (
        <Typography color="text.primary" fontWeight={700}>
          {lastLabel}
        </Typography>
      )}

    </Breadcrumbs>
  );
};

export default AppBreadcrumbs;
